import { MixerData } from '@Src/_basic/object/MixerTypes';
import { Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';

interface Props {
  row: MixerData;
}
export default function LastUpdateTimeColumnFormatter(props: Props) {
  const { row } = props;
  return <Typography variant="inherit">{moment(row.lastUpdateTime).format('YYYY/MM/DD HH:mm:ss')}</Typography>;
}
